module.exports = __webpack_public_path__ + "assets/img/266101.07425020.png";